import api from './api';
import { API_PREFIX } from '../config';

export const cardsService = {
  async getMyCards() {
    const response = await api.get(`${API_PREFIX}/cards/`);
    return response.data;
  },

  async getCard(cardId) {
    const response = await api.get(`${API_PREFIX}/cards/${cardId}`);
    return response.data;
  },

  async createCard(cardData) {
    const response = await api.post(`${API_PREFIX}/cards/`, cardData);
    return response.data;
  },

  async updateCard(cardId, cardData) {
    const response = await api.put(`${API_PREFIX}/cards/${cardId}`, cardData);
    return response.data;
  },

  async deleteCard(cardId) {
    await api.delete(`${API_PREFIX}/cards/${cardId}`);
  },

  async getPublicCard(uniqueId) {
    const response = await api.get(`${API_PREFIX}/public/card/${uniqueId}`);
    return response.data;
  },

  async downloadVCard(uniqueId) {
    const response = await api.get(`${API_PREFIX}/public/card/${uniqueId}/vcard`, {
      responseType: 'blob',
    });
    return response.data;
  },

  async trackClick(uniqueId, eventType) {
    await api.post(`${API_PREFIX}/public/card/${uniqueId}/track-click`, {
      event_type: eventType,
    });
  },

  async sendCardEmail(cardId, email) {
    const response = await api.post(`${API_PREFIX}/cards/${cardId}/send-email`, { email });
    return response.data;
  },

  async downloadCardPdf(cardId) {
    const response = await api.get(`${API_PREFIX}/cards/${cardId}/pdf`, {
      responseType: 'blob',
    });
    return response.data;
  },
};
